import React, { Component } from 'react';
import './_styles.scss';

class LayoutOneAddOn extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { groups: imagesAddOn = [] } = this.props || {};

		return (
			<div className="landing-comercial-1-addon landing-comercial-1-addon--flex">
				<div className="landing-comercial-1-addon__top">
					<img className="landing-comercial-1-addon__img" src={imagesAddOn[0].images.large} alt="AddOn-1" />
						<div className="landing-comercial-1-addon__overlay">
						<span className="landing-comercial-1-addon__title">{imagesAddOn[0].title}</span>
							</div>
				</div>
			</div>
		);
	}
}
export default LayoutOneAddOn;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialAddOn/Components/LayoutOneAddOn/index.jsx